import permission from '@/libraries/dataroom/permission/permission.js';
import folder from '@/libraries/dataroom/mixins/folder.js';
import document from '@/libraries/dataroom/mixins/document.js';
import template from '@/libraries/dataroom/mixins/template.js';
import file from '@/libraries/dataroom/mixins/file.js';
import addressbook from "@/octolo/addressbook/index.js";

export default {
    mixins: [permission, folder, document, template, file, addressbook],
    emits: ['config',],
    data: () => ({
        dataroomuploadFunction: null,
        last_timer_reload: "",
        is_busy: false,
    }),
    props: {
        busy: { type: Boolean, default: false },
        root: { type: Object },
        rootname: { type: String, },
        uid: { type: String, default: "root"},
        header: { type: Boolean, default: false},
        level: { type: Number, default: 0 },
        parent: { type: String,  },
        toolbar: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        add_folder_msg: { type: Boolean, default: false },
        add_document_msg: { type: Boolean, default: false },
        header_exclude: { type: Array, default: () => ["space", "print"] },
        permissions_enabled: { type: Boolean, default: false },
        in_space: { type: Boolean, default: false },
        fileapi: { type: String, default: "/dataroom/files/" },
        documentapi: { type: String, default: "/dataroom/documents/" },
    },
    computed: {
        nbColumns(){ return 8 - this.header_exclude.length; },
        folderapi(){ return this.in_space ? "/dataroom/space/" : "/dataroom/folders/"; }
    },
    methods: {
        isHeaderExclude(key){ return this.header_exclude.indexOf(key) > -1; },
        squeezeUid(prefix, uid){ return prefix+uid.replace(/-/g, ""); },
        folderUrl(uid, suffix){
            suffix = suffix || "";
            const url = !this.init_uid && !this.folder_init_uid ? "/api"+this.folderapi : "/api/"+this.$route.params.groupUid+this.folderapi;
            return uid ? url+uid+"/"+suffix : url+suffix;
        },
        documentUrl(uid, suffix){
            suffix = suffix || "";
            const url = "/api/"+this.$route.params.groupUid+this.documentapi;
            return uid ? url+uid+"/"+suffix : url+suffix;
        },
        fileUrl(uid, suffix){
            suffix = suffix || "";
            const url = this.file_url_api;
            return uid ? url+uid+"/"+suffix : url+suffix;
        },
        toastMessage(msg, type = 'info' ) {
            var toaster = document.createElement("div");
            toaster.innerHTML = msg;
            toaster.classList.add("dataroom-toaster");
            toaster.classList.add("dataroom-toaster-"+type);
            document.body.appendChild(toaster);
            setTimeout(function() {
                document.body.removeChild(toaster);
            }, 2000);
        }
    }
}
